import styled from 'styled-components';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { DateRange } from 'react-date-range';
import { mediaQueries } from '../../../constants/breakpoints';

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 24px;
  gap: 24px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  max-width: 90%;
  width: 100%;
  margin: 0px auto;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  @media ${mediaQueries.tablet} {
    max-width: 548px;
  }

  .rdrDayPassive .rdrDayNumber span {
    color: transparent;
  }
`;

export const Heading = styled.div`
  background-color: #ecf3f9;
  padding: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
`;

export const Copy = styled.div`
  font-weight: 500;
  font-size: 17px;
  text-align: center;
  margin: 30px 0;
  max-width: 370px;
  color: #000;
`;

export const DateContainer = styled.div`
  position: relative;
  margin-bottom: 30px;
`;

export const DateInput = styled.div`
  border: 1px solid #000;
  background-color: #fff;
  border-radius: 4px;
  padding: 8px 12px;
  color: #000;
  font-size: 1rem;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    font-size: 16px;
    position: relative;
    top: -1px;
  }
`;

export const StyledCalendarTodayIcon = styled(CalendarTodayIcon)`
  margin-right: 5px;
`;

export const StyledDateRange = styled(DateRange)`
  position: absolute;
  left: 0;
  top: 35px;
  border-radius: 10px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 30px 30px;
`;
